angular.module('lf.desktop')

.factory('slideinService', function () {

	var slideins = {};

	return {
		register: angular.noop,
		isRegistered: angular.noop,
		remove: angular.noop,
		show: angular.noop,
		hide: angular.noop
	}

});
